import {
  skipToken,
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/user-external-accounts/constants';
import type { UserExternalAccountApi } from '@/modules/user-external-accounts/types';

import { userExternalAccountsQueryKeys } from './queryKeys';

export const useUserExternalAccountsQuery = (
  userId: string | undefined,
  options?: Omit<
    UseQueryOptions<UserExternalAccountApi[] | undefined, unknown>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    queryKey: userExternalAccountsQueryKeys.list(userId),
    queryFn: userId
      ? async () => {
          const { data } = await fetchClient.GET(
            endpoints.userExternalAccounts,
            {
              params: { path: { userId } },
            },
          );
          return data;
        }
      : skipToken,
    ...options,
  });
};
